import { coreApi } from "../../app/core-api";
import { EntityCreateResult, EntityUpdateResult, PagedResult, PagedSearchFilter } from "../../app/types";
import { InvoiceCreateDto, Invoice, InvoiceFilter, InvoiceListItem, InvoiceStatusChange } from "./invoicing.types";

export const invoiceApi = {
    searchInvoices,
    getInvoice,
    createInvoice,
    updateInvoice,
    deleteInvoice,
    getNextInvoiceNumber,
    changeStatus,
};

const controller = "invoice";

function searchInvoices(filter: PagedSearchFilter<InvoiceFilter>) {
    return coreApi.get<PagedResult<InvoiceListItem>>(`${controller}/search`, {
        ...filter.filter,
        ...filter.pagination,
    });
}

function getInvoice(id: string) {
    return coreApi.get<Invoice>(`${controller}/${id}`);
}

function createInvoice(data: InvoiceCreateDto) {
    return coreApi.post<EntityCreateResult>(controller, data);
}

function updateInvoice(id: string, data: InvoiceCreateDto) {
    return coreApi.put<EntityUpdateResult>(`${controller}/${id}`, data);
}

function deleteInvoice(id: string) {
    return coreApi.remove(`${controller}/${id}`);
}

function getNextInvoiceNumber() {
    return coreApi.get<number>(`${controller}/next-invoice-no`);
}

function changeStatus(id: string, dto: InvoiceStatusChange): Promise<unknown> {
    return coreApi.patch(`${controller}/${id}/status`, dto);
}
